<template>
  <div id="order-wrapper" >
    <!--begin --- header ---begin  -->
    <div class="h-title-con">
      <div class="h-title">
        <span class="title-text"><span class="title-tip"></span>订单检查</span>
      </div>
      <div class="h-button-warpper">
        <el-button size="small" @click="save" type="primary">发送</el-button>
        <el-button size="small" @click="reset()" type="primary">重置</el-button>
      </div>
    </div>
    <!--end --- header ---end  -->
    <!--begin --- content ---begin  -->
    <div class="white-bg-radius sys-content w-label" id="orderCheck">
      <el-card class="box-card"  >
        <el-form :model="ruleForm" :rules="rules" ref="form"
                 label-position="right" label-width="190px" class="demo-ruleForm">
          <el-form-item label="检查序号：" prop="checkCode" class="ww-input-dia">
            <el-input v-model="ruleForm.checkCode" placeholder="请输入检查序号"></el-input>
          </el-form-item>
          <el-form-item label="SAP开单客户代号：" prop="sapCusCode">
            <el-input v-model="ruleForm.sapCusCode" placeholder="请输入SAP开单客户代号"></el-input>
          </el-form-item>
          <el-form-item label="达能送货分公司代号：" prop="wwsendCode">
            <el-input v-model="ruleForm.wwsendCode" placeholder="请输入达能送货分公司代号"></el-input>
          </el-form-item>
          <el-form-item label="达能开单分公司代号：" prop="wworderCode">
            <el-input v-model="ruleForm.wworderCode" placeholder="请输入达能开单分公司代号"></el-input>
          </el-form-item>
          <el-form-item label="达能开单渠道分销渠道代号：" prop="wwPlaceCode">
            <el-input v-model="ruleForm.wwPlaceCode" placeholder="请输入达能开单渠道分销渠道代号"></el-input>
          </el-form-item>
           <el-form-item label="达能开单渠道产品代号：" prop="wwPlacePCode">
            <el-input v-model="ruleForm.wwPlacePCode" placeholder="请输入达能开单渠道产品代号"></el-input>
          </el-form-item>
          <el-form-item label="SAP开单送达方代号：" prop="sapSendCode">
            <el-input v-model="ruleForm.sapSendCode" placeholder="请输入SAP开单送达方代号"></el-input>
          </el-form-item>
          <el-form-item label="是否工厂代发货：" prop="status">
            <el-radio-group v-model="ruleForm.status">
              <el-radio v-for=" (item,index) in statusList" :key="index" :label="item.value">{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="开单订单日期：" prop="orderDate">
            <el-date-picker
              v-model="ruleForm.orderDate"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyyMMdd"
              placeholder="请选择开单订单日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="行项目：" >
             <el-button size="small" @click="add" type="primary">新增</el-button>
          </el-form-item>
          <div class="tabWarp">
            <el-table  :data="ruleForm.list" border>
              <el-table-column
                prop="ruleForm.list.checkId"
                label="检查序号"
                align="center"
                width="200">
                <template slot-scope="{column,row,$index}">
                <el-input v-model="ruleForm.list[$index].checkId"
                ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="ruleForm.list.validNo"
                label="订单行号"
                align="center"
                width="200">
                <template slot-scope="{column,row,$index}"><el-input v-model="ruleForm.list[$index].validNo"></el-input></template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="ruleForm.list.matnr"
                label="达能物料代号"
                width="200">
                <template slot-scope="{column,row,$index}"><el-input v-model="ruleForm.list[$index].matnr"></el-input></template>
              </el-table-column>
              <el-table-column
                prop="ruleForm.list.abdat"
                label="允收生产日期"
                align="center"
                width="200">
                <template slot-scope="{column,row,$index}">
                  <el-date-picker
                    type="date"
                    v-model="ruleForm.list[$index].abdat"
                    format="yyyy-MM-dd"
                    value-format="yyyyMMdd"
                    placeholder="选择日期">
                  </el-date-picker>
                  </template>
              </el-table-column>
              <el-table-column
                prop="ruleForm.list.cmpre"
                label="SAP订货箱开单金额"
                align="center"
                width="200">
                <template slot-scope="{column,row,$index}"><el-input v-model="ruleForm.list[$index].cmpre"></el-input></template>
              </el-table-column>
              <el-table-column
                prop="ruleForm.list.kwmeng"
                label="SAP订货箱数"
                align="center"
                width="200">
                <template slot-scope="{column,row,$index}"><el-input v-model="ruleForm.list[$index].kwmeng"></el-input></template>
              </el-table-column>
              <el-table-column
                prop="date"
                label="操作"
                align="center"
               >
                <template slot-scope="{column,row,$index}"><el-button size="mini" @click="remove($index)" type="primary">删除</el-button></template>
              </el-table-column>
            </el-table>
          </div>
          <div class="tabWarp" >
            <label style="min-width:190px;">
              返回结果：
            </label>
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="ruleForm.remark">
            </el-input>
          </div>
        </el-form>
      </el-card>
    </div>

  </div>

</template>
<script>
  import { mapGetters } from 'vuex';
  import commonMixin from '@/mixins/common.js';
  import { methodPost, methodGet } from "../../api/request.js";
  export default {
    name: 'addOrganization',
    mixins: [commonMixin],
    data() {
      return {
        statusList: [
          { label: 'Y', value: 'Y' },
          { label: 'N', value: 'N' }
        ],
        ruleForm: {
          checkCode: '',
          sapCusCode: '',
          wwsendCode: '',
          wworderCode: '',
          wwPlacePCode: '',
          sapSendCode: '',
          wwPlaceCode: '',
          orderDate: '',
          status: 1,
          remark: '',
          list: [
            {
              checkId: '', validNo: '', matnr: '', abdat: '', cmpre: '', kwmeng: ''
            }
          ] },
        rules: {
          checkCode: [
            { required: true, message: '此项为必填项', trigger: 'blur' }
          ],
          orderDate: [
            { required: true, message: '此项为必填项', trigger: 'blur' }
          ],
          status: [
            { required: true, message: '此项为必填项', trigger: 'blur' }
          ]

        }

      }
    },
    methods: {
      back(isRefresh) {
        const path = '/organizationManagement/index'
        this.goBack(path)
        if (isRefresh) {
          this.$nextTick(() => {
            this.$eventBus.$emit('refresh-custom-table')
          })
        }
      },
      reset() {
        this.ruleForm.checkCode = '';
        this.ruleForm.sapCusCode = '';
        this.ruleForm.wwsendCode = '';
        this.ruleForm.wwPlaceCode = '';
        this.ruleForm.wwPlacePCode = '';
        this.ruleForm.wworderCode = '';
        this.ruleForm.sapSendCode = '';
        this.ruleForm.orderDate = '';
        this.ruleForm.status = '';
        this.ruleForm.list = [{ checkId: '', validNo: '', matnr: '', abdat: '', cmpre: '', kwmeng: '' }]
        this.ruleForm.remark = '';
      },
      save() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitForm()
          } else {
            console.log('error submit!!')
          }
        })
      },
      submitForm() {
        const URL = '/material/initOrderData'
        const params = {
          type: '1',
          orderCheck: { checkId: this.ruleForm.checkCode,
            isFactdev: this.ruleForm.status,
            kunnr: this.ruleForm.sapCusCode,
            kunnr1: this.ruleForm.sapSendCode,
            prsdt: this.ruleForm.orderDate,
            spart: this.ruleForm.wwPlacePCode,
            vkorg: this.ruleForm.wworderCode,
            vkorg1: this.ruleForm.wwsendCode,
            vtweg: this.ruleForm.wwPlaceCode,
            orderCheckItem: this.ruleForm.list
          }
        }
        methodPost(URL, params).then(res => {
          console.log(1111)
          if (res.code === 0) {
            // this.$message.success(`${this.ruleForm.id ? '发送' : '创建'}成功`)
            this.ruleForm.remark = res.data;
            // this.back(true)
          } else {
            this.$message.error(res.message || '发送出错，请稍后再试')
          }
        })
      },
      // 添加
      add() {
        this.ruleForm.list.push({
          checkId: '', validNo: '', matnr: '', abdat: '', cmpre: '', kwmeng: ''
        })
      },
      // 删除
      remove(index) {
        this.ruleForm.list.splice(index, 1)
      },
      // 出现弹框里边的方法
      editEvent(val) {
        methodGet('/sysOrganize/getOrganizeById/' + val).then(res => {
          if (res.code === 0) {
            this.ruleForm.organizeCode = res.data.organizeCode;
            this.ruleForm.organizeName = res.data.organizeName;
            this.ruleForm.organization = res.data.upOrganizeName;
            this.ruleForm.id = res.data.id;
            this.ruleForm.remark = res.data.remark
            this.ruleForm.status = res.data.status
            this.ruleForm.parentId = res.data.parentId
            if (this.ruleForm.parentId === 0) {
              this.isUpdate = true;
            }
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    computed: {
      ...mapGetters([
        'sidebar'
      ])
    },
    mounted() {

    }

  }
</script>

<style lang="scss" slope>
  #sys-wrapper {
    position: relative;
    .sys-content {
      .el-form-item__label {
        padding-right: 5px !important;
      }
      .el-form-item__error{
        left: 105%;
        width: 200px;
        top: 25%;
      }
      .el-form-item{
        margin-bottom: 10px;
      }

    }
    .sys-footer{
      position: absolute;
      bottom: 0px;
      left: 0px;
      margin-left: 20px;
      height: 60px;
      width: 100%;
    }
    .content-params {
      padding:5px 20px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      overflow: hidden;
      .params {
        min-width:340px;
        margin: 5px 0;
        font-size: 0;
      }
      .custom_label {
        min-width: 80px;
        display:inline-block;
        font-size: 14px;
        font-weight:700;
        text-align: right;
        color:#606266;
        i {
          color: red;
          font-style: normal;
          vertical-align: middle;
        }
      }
    }
}
.tabWarp{
  padding:20px 0 0;
  display:flex;
  .el-input{
    width:178px!important;
    margin:5px 0!important;
  }
  label{
    color: #606266;
    font-size: 12px;
    text-align:right;
  }
}
.el-date-editor.el-input, #app #order .el-date-editor.el-input__inner{
   width:178px!important;
}
</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/orderCheck/index.vue